import type { CloseEditActivityAction } from './typings'

export const closeEditActivityActionCreator = (): CloseEditActivityAction => ({
  type: 'activitySummary/closeEditActivity',
})
